var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-logo-container"},[_c('a',{attrs:{"href":"https://www.code-crew.de/","target":"_blank"}},[(_vm.type === 'black')?_c('img',{attrs:{"src":"https://logos.code-crew.de/cc_logo_black.png"}}):_vm._e(),(_vm.type === 'white')?_c('img',{attrs:{"src":"https://logos.code-crew.de/cc_logo_white.png"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }